<template>
  <div id="ProductCard">
    <span v-if="product.discountPercentage" class="dicountspan"
      >-{{ product.discountPercentage }}%</span
    >
    <div class="image-conatainer">
      <img
        width="100%"
        height="100%"
        @click="navigate(product.slug)"
        class="imgggg zoomIn"
        :src="`${imageBaseURL}${product.images[0]}`"
      />
    </div>
    <div @click="navigate(product.slug)" class="buttons">
      <p @click="navigate(product.slug)" :title="product.title" class="h4">
        {{ substring(product.title) }}
      </p>
      <button class="botn botn-blue me-2">
        {{ product.price.showPrice | toCurrency }} IQD
      </button>
    </div>
  </div>
</template>

<script>
import ENV from '../../../assets/js/ENV.config.js';
import Utility from '../../../assets/js/utilities.services.js';

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      imageBaseURL: ENV.website.imageBaseURL,
    };
  },
  methods: {
    navigate(slug) {
      this.$router.push({ path: `/product/${slug}` });
    },
    substring(str, len = 20) {
      return Utility.substring(str, len);
    },
  },
};
</script>

<style>
.buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.h4,
.imgggg,
.botn-blue {
  cursor: pointer;
}
.imgggg {
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
  width: 260px;
  height: 216px;
  padding: 30px;
}
.botn {
  width: 150px;
  font-size: 16px;
  border-radius: 20px;
  height: 30px;
  outline: none;
  transition: all 0.3s ease;
  border: none;
}
.botn-blue {
  position: relative;
  color: white;
  text-align: center;
  background: linear-gradient(to right, #05cefc, #5659ce);
  font-size: 16px;
}

.image-conatainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#ProductCard {
  border-right: 1px solid grey;
  padding: 10px;
}
</style>
